/* Native Shopify forms remain usable without JavaScript. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}');
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100);
  let header, hero, frame = false, toastTimer;

  function updateHeader() {
    frame = false;
    if (!header) return;
    const threshold = hero ? hero.offsetTop + hero.offsetHeight - 90 : 150;
    const fixed = window.scrollY > threshold;
    header.classList.toggle('is-solid', fixed);
    header.classList.toggle('is-light', !!hero && hero.dataset.headerTone === 'light' && !fixed);
  }
  function setupHeader() {
    header = document.querySelector('[data-site-header]');
    const candidate = document.querySelector('#MainContent [data-hero]');
    hero = candidate && candidate.closest('#MainContent')?.firstElementChild?.contains(candidate) ? candidate : null;
    document.body.classList.toggle('has-hero', !!hero);
    const wrapper = header?.closest('.header-section');
    if (wrapper) wrapper.style.minHeight = hero ? '0' : (window.innerWidth < 750 ? '94px' : '118px');
    updateHeader();
  }
  window.addEventListener('scroll', () => {
    if (!frame) { frame = true; requestAnimationFrame(updateHeader); }
  }, { passive: true });
  window.addEventListener('resize', setupHeader, { passive: true });
  document.addEventListener('hero:change', updateHeader);

  function activateTab(section, id, focus = false) {
    section.querySelectorAll('[data-showcase-tab]').forEach(tab => {
      const selected = tab.dataset.showcaseTab === id;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      tab.classList.toggle('is-active', selected);
      if (selected && focus) tab.focus({ preventScroll: true });
    });
    section.querySelectorAll('[data-showcase-panel]').forEach(panel => {
      panel.hidden = panel.dataset.showcasePanel !== id;
      panel.classList.toggle('is-active', !panel.hidden);
    });
  }

  function activateMedia(gallery, id) {
    if (!gallery || !gallery.querySelector(`[data-product-media-id="${CSS.escape(String(id))}"]`)) return;
    gallery.querySelectorAll('[data-product-media-id]').forEach(panel => {
      const wasVisible = !panel.hidden;
      panel.hidden = panel.dataset.productMediaId !== String(id);
      if (panel.hidden) {
        panel.querySelectorAll('video').forEach(video => video.pause());
        if (wasVisible) panel.querySelectorAll('iframe[src]').forEach(video => { video.src = video.src; });
      }
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const active = thumb.dataset.galleryThumb === String(id);
      thumb.setAttribute('aria-current', String(active));
    });
  }
  function setupGalleries(scope = document) {
    scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      activateMedia(gallery, gallery.dataset.initialMediaId || gallery.querySelector('[data-product-media-id]')?.dataset.productMediaId);
    });
  }

  function selectedVariant(section) {
    const data = JSON.parse(section.querySelector('[data-product-json]')?.textContent || '{}');
    const selectedId = section.querySelector('[data-product-form] [name="id"]')?.value;
    return data.variants?.find(variant => String(variant.id) === selectedId);
  }

  function refreshSellingPlans(section, variant) {
    const select = section.querySelector('[data-selling-plan-select]');
    if (!select) return;
    const previousId = select.value;
    const allocations = variant.selling_plan_allocations || [];
    const options = [];
    if (!variant.requires_selling_plan) options.push(new Option(`One-time purchase — ${money(variant.price)}`, ''));
    allocations.forEach(allocation => options.push(new Option(`${allocation.selling_plan.name} — ${money(allocation.price)}`, String(allocation.selling_plan.id))));
    select.replaceChildren(...options);
    if (options.some(option => option.value === previousId)) select.value = previousId;
    select.disabled = !allocations.length;
    select.required = !!variant.requires_selling_plan;
    const field = section.querySelector('[data-selling-plan-field]');
    if (field) field.hidden = !allocations.length;
  }

  function updatePurchaseState(section, variant) {
    if (!variant) return;
    const planId = section.querySelector('[data-selling-plan-select]')?.value;
    const allocation = variant.selling_plan_allocations?.find(item => String(item.selling_plan.id) === planId);
    const price = allocation ? allocation.price : variant.price;
    const comparePrice = allocation ? allocation.compare_at_price : variant.compare_at_price;
    section.querySelectorAll('[data-product-price]').forEach(el => { el.textContent = money(price); });
    section.querySelectorAll('[data-product-compare-price]').forEach(el => {
      el.hidden = !(comparePrice > price);
      el.textContent = comparePrice > price ? money(comparePrice) : '';
    });
    const canPurchase = variant.available && (!variant.requires_selling_plan || !!allocation);
    const button = section.querySelector('[data-product-submit]');
    if (button) {
      button.disabled = !canPurchase || section.querySelector('[data-product-form]')?.dataset.submitting === 'true';
      const label = button.querySelector('[data-product-submit-label]');
      if (label) label.textContent = canPurchase ? (button.dataset.addLabel || 'Add to cart') : (variant.available ? (button.dataset.unavailableLabel || 'Unavailable') : (button.dataset.soldOutLabel || 'Sold out'));
    }
    const payment = section.querySelector('.product-dynamic-checkout');
    if (payment) payment.hidden = !canPurchase;
    const buyNow = section.querySelector('[data-buy-now]');
    if (buyNow) buyNow.disabled = !canPurchase || section.querySelector('[data-product-form]')?.dataset.submitting === 'true';
  }

  function updateProductUrl(section, variant) {
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    const planId = section.querySelector('[data-selling-plan-select]')?.value;
    if (planId) url.searchParams.set('selling_plan', planId);
    else url.searchParams.delete('selling_plan');
    history.replaceState({}, '', url);
  }

  function changeVariant(select) {
    const section = select.closest('[data-product-section]');
    if (!section) return;
    const variant = selectedVariant(section);
    if (!variant) return;
    refreshSellingPlans(section, variant);
    updatePurchaseState(section, variant);
    const quantity = section.querySelector('[data-quantity] input');
    if (quantity) {
      quantity.min = variant.quantity_rule?.min || 1;
      quantity.step = variant.quantity_rule?.increment || 1;
      if (variant.quantity_rule?.max != null) quantity.max = variant.quantity_rule.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
    }
    activateMedia(section.querySelector('[data-product-gallery]'), variant.featured_media?.id || variant.featured_image?.id);
    updateProductUrl(section, variant);
    section.querySelectorAll('[data-product-status]').forEach(el => { el.textContent = ''; });
  }

  function showToast(message, error = false) {
    const toast = document.querySelector('[data-cart-status]');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.replaceChildren(document.createTextNode(message));
    toast.dataset.error = String(error);
    if (!error) {
      const link = document.createElement('a');
      link.href = config.cartPageUrl || '/cart';
      link.textContent = 'View cart';
      toast.append(link);
    }
    toast.hidden = false;
    toastTimer = setTimeout(() => { if (!toast.contains(document.activeElement)) toast.hidden = true; }, 7000);
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch || !form.checkValidity()) return;
    if (event.submitter && event.submitter.name && event.submitter.name !== 'add') return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = event.submitter || form.querySelector('[type=submit]');
    const status = form.querySelector('[data-product-status]');
    const formData = new FormData(form);
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    const buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) buyNow.disabled = true;
    if (status) status.textContent = 'Adding to your cart…';
    try {
      if (window.HomiHavenCartDrawer) {
        const result = await window.HomiHavenCartDrawer.add(formData, button);
        if (status) status.textContent = `${result.product_title || result.title || 'Item'} added to your cart.`;
        return;
      }
      const response = await fetch(config.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check the quantity and try again.');
      const message = `${result.product_title || result.title || 'Item'} added to your cart.`;
      if (status) status.textContent = message;
      showToast(message);
      // A failed badge refresh must not turn a successful cart addition into an error.
      try {
        const cartResponse = await fetch(config.cartUrl || '/cart.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        }
      } catch (_) { /* The native cart page remains the source of truth. */ }
    } catch (error) {
      const message = error instanceof TypeError ? 'Connection interrupted. Open your cart to check whether the item was added before trying again.' : error.message;
      if (status) status.textContent = message;
      showToast(message, true);
    } finally {
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      const section = form.closest('[data-product-section]');
      if (section) updatePurchaseState(section, selectedVariant(section));
      else if (button) button.disabled = false;
    }
  });

  document.addEventListener('click', event => {
    const scroll = event.target.closest('[data-scroll-next]');
    if (scroll) {
      const target = document.getElementById(scroll.getAttribute('href').slice(1));
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: prefersReducedMotion() ? 'instant' : 'smooth', block: 'start' }); target.focus({ preventScroll: true }); }
    }
    const stepButton = event.target.closest('[data-quantity-change]');
    if (stepButton) {
      const input = stepButton.closest('[data-quantity]')?.querySelector('input[type=number]');
      if (input) {
        const direction = Number(stepButton.dataset.quantityChange);
        try { direction > 0 ? input.stepUp() : input.stepDown(); } catch (_) { input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + direction); }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const tab = event.target.closest('[data-showcase-tab]');
    if (tab) activateTab(tab.closest('[data-showcase]'), tab.dataset.showcaseTab);
    const tabStep = event.target.closest('[data-showcase-prev],[data-showcase-next]');
    if (tabStep) {
      const section = tabStep.closest('[data-showcase]');
      const tabs = [...section.querySelectorAll('[data-showcase-tab]')];
      const active = tabs.findIndex(el => el.getAttribute('aria-selected') === 'true');
      const next = tabs[(active + (tabStep.hasAttribute('data-showcase-next') ? 1 : -1) + tabs.length) % tabs.length];
      if (next) activateTab(section, next.dataset.showcaseTab);
    }
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) { event.preventDefault(); activateMedia(thumb.closest('[data-product-gallery]'), thumb.dataset.galleryThumb); }
    const menu = event.target.closest('[data-mobile-menu]');
    if (menu && (event.target.closest('[data-menu-close]') || event.target.closest('.mobile-menu__panel a'))) closeMenu(menu);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) changeVariant(event.target);
    if (event.target.matches('[data-selling-plan-select]')) {
      const section = event.target.closest('[data-product-section]');
      const variant = section && selectedVariant(section);
      if (variant) { updatePurchaseState(section, variant); updateProductUrl(section, variant); }
    }
  });

  function closeMenu(menu) {
    menu.open = false;
    document.body.classList.remove('menu-open');
    menu.querySelector('summary')?.focus({ preventScroll: true });
  }
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-mobile-menu]')) {
      document.body.classList.toggle('menu-open', event.target.open);
      if (event.target.open) event.target.querySelector('[data-menu-close]')?.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('[data-mobile-menu][open]');
    if (menu) {
      if (event.key === 'Escape') { closeMenu(menu); event.preventDefault(); return; }
      if (event.key === 'Tab') {
        const focusable = [...menu.querySelectorAll('.mobile-menu__panel a, .mobile-menu__panel button')].filter(el => !el.disabled);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { last?.focus(); event.preventDefault(); }
        else if (!event.shiftKey && document.activeElement === last) { first?.focus(); event.preventDefault(); }
      }
    }
    const tab = event.target.closest('[data-showcase-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const section = tab.closest('[data-showcase]');
    const tabs = [...section.querySelectorAll('[data-showcase-tab]')];
    const index = tabs.indexOf(tab);
    const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(section, tabs[nextIndex].dataset.showcaseTab, true);
  });

  // Pointer dragging enhances the native horizontal gallery; touch keeps native scrolling.
  function setupDrag(scope = document) {
    scope.querySelectorAll('.home-testimonials__gallery').forEach(gallery => {
      if (gallery.dataset.dragReady) return;
      gallery.dataset.dragReady = 'true';
      let startX, startScroll, dragging = false;
      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button')) return;
        startX = event.clientX; startScroll = gallery.scrollLeft; dragging = true;
        gallery.setPointerCapture(event.pointerId);
      });
      gallery.addEventListener('pointermove', event => {
        if (!dragging) return;
        gallery.scrollLeft = startScroll - (event.clientX - startX);
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => gallery.addEventListener(name, () => { dragging = false; }));
      gallery.querySelectorAll('img').forEach(img => { img.draggable = false; });
    });
  }
  function init(scope = document) {
    setupHeader(); setupGalleries(scope); setupDrag(scope);
    scope.querySelectorAll('[data-product-submit]').forEach(button => {
      const label = button.querySelector('[data-product-submit-label]');
      if (label && !button.disabled) button.dataset.addLabel = label.textContent;
    });
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const variant = selectedVariant(section);
      if (variant) { refreshSellingPlans(section, variant); updatePurchaseState(section, variant); }
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(setupHeader));
  document.addEventListener('shopify:section:reorder', setupHeader);
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-showcase-panel]');
    if (panel) activateTab(panel.closest('[data-showcase]'), panel.dataset.showcasePanel);
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  init();
})();
